(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["@bytel/context-helpers"] = factory(require("react"));
	else
		root["@bytel/context-helpers"] = factory(root["react"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__297__) {
return 